import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"


export async function getSystemInfo() {
  const systemApi = "/system/information";
  let systemInfo = {}

  await axios
    .get(systemApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.cpu != undefined) {
        systemInfo.cpu = response.data.cpu
      }

      if (response.data.memory != undefined) {
        systemInfo.memory = response.data.memory
      }

      if (response.data.disk != undefined) {
        systemInfo.disk = response.data.disk
      }
    })

  return systemInfo
}

export async function purgeSystem() {
  const systemApi = "/system/maintain/purge";

  await axios
    .get(systemApi,)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        window.console.log(app.$t("systemNetworkError"))

      } else {
        window.console.log(error.response.data.status.message)
      }
      throw (error)
    })
}

export async function backupSystem() {
  const systemApi = "/system/maintain/backup";

  await axios
    .get(systemApi, { responseType: "arraybuffer" })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      let config = response.data
      let blob = new Blob([config], {
        type: "application/zip",
      });

      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      let fileName = "config.zip";
      link.download = fileName;
      link.click();
    })
}

export async function restoreSystem(data) {
  const systemApi = "/system/maintain/restore";

  await axios
    .post(systemApi, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
}

export async function restartServer() {
  const systemApi = "/system/maintain/server/restart";

  await axios
    .post(systemApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
}

export async function pingServer() {
  const systemApi = "/system/maintain/ping";

  await axios
    .get(systemApi);
}

export async function getCoolDown() {
  const systemApi = "/system/cooldown";
  let coolDown = {}

  await axios
    .get(systemApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.is_enable != undefined && response.data.cool_down != undefined) {
        coolDown.is_enable = response.data.is_enable
        coolDown.cool_down = response.data.cool_down
      }
    })

  return coolDown
}

export async function setCoolDown(data) {
  const systemApi = "/system/cooldown";

  await axios
    .post(systemApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}